import * as FileUtils from "@repoflow/common/file-utils";
import * as BucketLib from "@common/code/bucket";

export const Component = ({
  url: urlRaw,
  className = "w-100",
  type = null,
}) => {

  if (!urlRaw) {
    return null;
  }

  const url = urlRaw;
  const ext = FileUtils.getExtension(url);

  return (
    <div className="text-center">
      {FileUtils.isImageExt(ext) || type === "image" ? (
        <img data-zoom="85" className={className} alt="" src={url} />
      ) : ext === "ico" ? (
        <img alt="" src={url} />
      ) : (
        <a href={url}>
          <i className="fa fa-file-o"></i>
        </a>
      )}
    </div>
  );
};

export const FileRender = ({
  bucketId,
  fileId,
  ext,
  className = "w-100",
}) => {
  const url = BucketLib.getUrl(bucketId, fileId, ext);
  return <Component url={url} className={className} />;
};
